/**
 * @file 郵便番号整形
 */
'use strict';

/**
 * @classname PostalCode
 * @classdesc 郵便番号整形
 */
export default class PostalCode {
	/**
	 * @constructor
	 * @param {jQuery} $e - .p-postal-code
	 */
	constructor($e) {
		console.log('PostalCode.constructor');
		this._$e = $e;
		$e.on('keyup', ()=> this.onKeyUp());
	};


	/**
	 * 郵便番号分割
	 *
	 * @memberof PostalCode
	 * @return {undefined}
	 */
	onKeyUp() {
		console.log('PostalCode.onKeyUp');
		const val = this._$e.val();
		if(val.match(/^\d{7}$/)){
			const postalCode = `${val.substring(0,3)}-${val.substring(3,7)}`;
			this._$e.val(postalCode);
		}
	};
}
